





















import Authenticate from './scripts';
export default Authenticate;
